import { render, staticRenderFns } from "./AdvertiseReport.vue?vue&type=template&id=f12b72ea"
import script from "./AdvertiseReport.vue?vue&type=script&lang=js"
export * from "./AdvertiseReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports